import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, Input, SimpleChanges } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material'
import { Observable } from 'rxjs';
import { CreateFolderModalComponent } from './create-folder-modal/create-folder-modal.component';
import { FolderService } from '../services/folder.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { UtilityService } from './../services/utility.service'
declare var $: any;

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html',
  styleUrls: ['./folder.component.scss']
})
export class FolderComponent implements OnInit {

  allFolders = [];
  sharedFile = [];
  preventSingleClick = false;
  timer: any;
  delay: Number;
  display = false;
  currentUser;
  loading;
  secledtIndex = 0;
  isMyDocs: Boolean = false;

  // @ViewChild(ContextMenuComponent, { static: false }) public basicMenu: ContextMenuComponent;
  details: any;
  @Input('deletedFile') deletedFile: any;
  @Input('subFolders') subFolder: any;
  @Input('removeCssClass') removeCssClass: any;
  @Input('updatedFolder') updatedFolder: any;
  @Input('folderIdFromParams') folderIdFromParams: any;
  @Input('activeFile') activeFile: any;
  @Input('preciousFolderIndex') preciousFolderIndex: any;
  @Input('hideNoFolder') hideNoFolder: any;


  @Input('folder') folder: any;
  @Input('index') i: any;
  @Input('displayCheckBoxes') displayCheckBoxes: any;
  @Input('changeIndex') indexChange
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileDropped: EventEmitter<any> = new EventEmitter<any>();
  @Output() folderName: EventEmitter<any> = new EventEmitter<any>();
  @Output() folderCheckEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() labourDocumentId: EventEmitter<any> = new EventEmitter<any>();
  showCreateBtn: boolean = false;
  showSharedFiles: boolean = false;
  allFoldersCopy: any[];
  cardIndex: any = 0;
  folderId: any;
  newFolderIndex: any = -1;
  destFolderName: any;
  hideMsg: any;
  noFolderMsg: any;
  user;
  noDataMsg = {
    title: "No Folders!",
    data: "You have not yet created any folders"
  }
  selectedFolders = [];
  constructor(public _folderService: FolderService, private activatedRoute: ActivatedRoute
    , public dialog: MatDialog, public _snackBar: MatSnackBar, public router: Router, public _utilityService: UtilityService) {
  }

  ngOnInit() {

    if (this.router.url.includes('/single-folder') || this.router.url.includes('/mydocuments/list')) {
      console.log("isMyDocs=>", this.isMyDocs)
      this.isMyDocs = false;
    } else {
      this.isMyDocs = true;
    }


    console.log('hideNoFolder=========>', this.hideNoFolder);
    this.loading = true;
    this.activatedRoute.params.subscribe(params => {
      this.folderId = params['id'];
      if (this.folderId) {
        this.showCreateBtn = true
        this.showSharedFiles = true
      }
    })
    // if (this.router.url.includes('/mydocuments')) {
    //   this.showCreateBtn = true
    //   this.showSharedFiles = true
    // }
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("what is the user role=========", this.user);


    if (this.user.isAdmin) {
      this.noFolderMsg = "No Folder Created";
    } else {
      this.noFolderMsg = "No Folder Shared";
    }
    $(document).ready(function () {
      console.log("ready!");
      // $('#folder_card_0').addClass('selectedBorder')
    });
    // if (this.currentUser.userRole == 'admin') {
    //   this.getFolders();
    // } else {
    //   this.getSharedFolders();
    //   this.getSharedFiles();
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.currentUser = JSON.parse(localStorage.currentUser);
    console.log("changes========>", changes)
    if (changes.deletedFile) {
      let index = _.findIndex(this.allFolders, function (o) {
        return o._id.toString() == changes.deletedFile.currentValue.fileId.toString();
      })
      if (index > -1) this.allFolders.splice(index, 1)
    }
    if (changes.subFolder) {
      console.log("changes.subFolder.currentValue typeof", typeof changes.subFolder.currentValue);
      this.allFolders = changes.subFolder.currentValue;
      this.loading = false
      console.log("This.allFolders", this.allFolders);
      if (this.allFolders.length > 0) {
        $(document).ready(function () {
          console.log("ready!");
          $('.selectedBorder').removeClass('selectedBorder')
          // $('#folder_card_0').addClass('selectedBorder')
        });
      }
    }
    // if (changes.subFolder == undefined && this.router.url.includes('/mydocuments') && this.currentUser.userRole == 'admin') {
    //   this.loading = true
    //   this.getFolders()
    // }
    // if (changes.subFolder == undefined && this.currentUser.userRole != 'admin') {
    //   this.loading = true;
    //   this.getSharedFolders();
    //   this.getSharedFiles();
    // }
    if (changes.removeCssClass != undefined) {
      if (changes.removeCssClass.currentValue == true) {
        $('.parent_row').removeClass('col-width-class');
      }
    }
    if (changes.updatedFolder) {
      let index = _.findIndex(this.allFolders, function (o) {
        return o._id.toString() == changes.updatedFolder.currentValue._id.toString();
      })
      if (index > -1) this.allFolders.splice(index, 1, changes.updatedFolder.currentValue)

      else {
        console.log("this.subFolder", this.subFolder);
        let index = _.findIndex(this.subFolder, function (o) {
          return o._id.toString() == changes.updatedFolder.currentValue._id.toString();
        })
        console.log("Index", index);
        if (index > -1) this.subFolder.splice(index, 1, changes.updatedFolder.currentValue)
      }
      console.log("this.subFolder", this.subFolder);
    }
    if (changes.activeFile) {
      this.activeFile = changes.activeFile.currentValue

    }
    if (changes.preciousFolderIndex && changes.preciousFolderIndex.currentValue) {
      this.preciousFolderIndex = changes.preciousFolderIndex.currentValue
    }


    if (changes.hideNoFolder && changes.hideNoFolder.currentValue) {
      console.log('changes.hideNoFolder==>', changes.hideNoFolder.currentValue);
      // this.afterFilter = ""
      this.hideMsg = changes.hideNoFolder.currentValue
    }


    if (changes.indexChange && changes.indexChange.currentValue) {
      this.secledtIndex = -1
      if (this.i == 0) {
        console.log("all single card indedx ", this.i);
        console.log("what is current index", this.secledtIndex);
        this.secledtIndex = this.i

        $("#folder_card_" + this.i).addClass('selectedBorder')
        $('.parent_row').addClass('col-width-class');
        // this.cd.detectChanges()
      }
    }
  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  // shareWith(singleFolder){
  //   console.log("ShareWith", singleFolder);
  //   this.openDialog(ShareFileModalComponent).subscribe(users=>{
  //     console.log('Users', users);
  //     users.file = singleFolder.item;
  //     console.log("AFTER ADDING ID", users);
  //     this.openSnackBar("Shared Successfully", "ok")
  //   })
  // }

  createFolder() {
    let folderId
    this.activatedRoute.params.subscribe(params => {
      folderId = params['id'];
      console.log("Calling getLearners with jobid = ", folderId);
    });
    this.openDialog(CreateFolderModalComponent, folderId).subscribe(folder => {
      if (folder == undefined) return
      console.log("FOLDER NAME RECIEVED", folder);
      this.allFolders.push(folder);
    })
  }

  getFolders() {
    this._folderService.getFolders().subscribe((folders) => {
      console.log('Folders:::::::::', folders);
      this.allFolders = folders;
      this.allFoldersCopy = this.allFolders
      this.loading = false
    });
  }

  openFileDetails(file) {
    // event same as single-instructor okay
    console.log("Open file details", file);
    this.getFileDetails.emit(file)
  }

  getSharedFolders() {
    this._folderService.getSharedFolders().subscribe((folders) => {
      console.log('Folders', folders);
      this.allFolders = folders;
      this.loading = false
    });
  }

  getSharedFiles() {
    this._folderService.getSharedFiles().subscribe((files) => {
      console.log('files List', files);
      this.sharedFile = files;
      this.loading = false
    });
  }

  singleClick(event, singleFolder, i) {
    this.secledtIndex = i;
    this.cardIndex = i;
    console.log("Single Click Event", event);
    if (this.preciousFolderIndex && this.preciousFolderIndex != i) {
      $("#folder_card_" + this.preciousFolderIndex).removeClass('selectedBorder')
    }
    // let id = "#folder_card_" + i;
    this.removeCssClass = false
    console.log("this.removeCssClss", this.removeCssClass);
    console.log("this.cardIndex", this.cardIndex);
    if (this.cardIndex != 0) {
      $("#folder_card_0").removeClass('selectedBorder')
    }
    $("#folder_card_" + i).addClass('selectedBorder')
    $('.parent_row').addClass('col-width-class');
    this.preventSingleClick = false;
    const delay = 200;
    this.timer = setTimeout(() => {
      if (!this.preventSingleClick) {
        this.details = singleFolder;
        console.log("singleFolder", this.details);
        this.display = true;
      }
    }, delay);
    console.log("value of sinlge file detaails", singleFolder);

    this.getFileDetails.emit({ file: singleFolder, index: this.cardIndex })

  }

  doubleClick(event, singleFolder) {
    console.log("Double Click Event", event);
    this.preventSingleClick = true;
    clearTimeout(this.timer);
    console.log("Double Click");
    console.log("singleFolder", this.router.url.includes('labour-job/view'));
    if (!this.isMyDocs) this.router.navigate(['/mydocuments/single-folder/', singleFolder._id])
    else {
      console.log("THIS IF FOR LABOUR JOB");
      this.labourDocumentId.emit(singleFolder._id)
    }
    // 
  }

  checkChanged(event, index, data) {
    console.log("EVENT=====>>>>>", event)
    this.folderCheckEvent.emit({ event: event, index: index, data: data })
    // if(event.checked == true){
    //   this.selectedFolders.push(data._id)
    // }
    // else{
    //   let temp = _.findIndex(this.selectedFolders, function(o){ 
    //     console.log("o", o, "data._id", data._id)
    //     return o == data._id
    //   })
    //   console.log("temp", temp)
    //   if( temp > -1){
    //     this.selectedFolders.splice(temp, 1)
    //   }
    // }
    // console.log("this.selectedFolders=====>>>>>", this.selectedFolders)
  }

  // drop(event: CdkDragDrop<string[]>, text) {
  //   console.log("CARD DROP EVENT", event, text);
  //   // console.log("event", event.previousIndex, this.allFolders[event.previousIndex])
  //   console.log("Previous index", this.allFolders);
  //   // let temp1 = this.allFolders[event.previousIndex]
  //   // let temp2 = this.allFolders[event.currentIndex]
  //   // this.allFolders[event.previousIndex] = temp2
  //   // this.allFolders[event.currentIndex] = temp1
  //   // console.log("event", event.currentIndex, this.allFolders[event.currentIndex])
  //   // if (event.currentIndex == event.previousIndex) return
  //   if (event.previousContainer.id == "files") {
  //     console.log("A FILE IS DROPPED IN THE FOLDER")
  //     if (this.newFolderIndex >= 0) {
  //       let obj = {
  //         fileIndex: event.previousIndex,
  //         previousFolder: this.folderId,
  //         newFolderId: this.allFolders[this.newFolderIndex]
  //       }
  //       console.log("OBJECT!!", obj)
  //       this.fileDropped.emit(obj)
  //     }
  //     else {
  //       this.openSnackBar("Please Drop On a Folder", "OK")
  //     }
  //   }
  //   else {
  //     console.log("IN ELSE", event.previousIndex)
  //     if (this.newFolderIndex && this.newFolderIndex == event.previousIndex || event.previousIndex == event.currentIndex) return
  //     else if (this.newFolderIndex >= 0) {
  //       // let childId = this.allFolders[event.currentIndex];
  //       let childId = this.allFolders[this.newFolderIndex]
  //       let folderId = this.allFolders[event.previousIndex];
  //       console.log("parent", childId);
  //       console.log("child", folderId);
  //       let data = {
  //         folderId: folderId._id,
  //         childId: childId._id,
  //         parent: this.folderId
  //       }
  //       console.log("New data", data);
  //       this.allFolders.splice(event.previousIndex, 1)
  //       this._folderService.changeFolderParent(data).subscribe(res => {
  //         console.log("Updated hierarchy", res);
  //       })
  //       if (this.folderId) {
  //         console.log("this.folderId", this.folderId);
  //         console.log("this.subFolder", this.subFolder);
  //         let index = _.findIndex(this.subFolder, function (o) { console.log("o._id", o._id); return o._id == folderId._id })
  //         if (index > -1) this.subFolder.splice(index, 1)
  //       }
  //     }

  //   }

  // }
  // sortedFolderName(event){
  //   let folderName
  //   console.log("event.currentIndex", event.currentIndex)
  //   if (event.currentIndex < this.allFolders.length){
  //     folderName = this.allFolders[event.currentIndex].title
  //     this.folderName.emit(folderName)
  //     console.log('sorting event', folderName)
  //   }
  // }
  dragMoved(event) {
    console.log("event on drag move", event)
  }
  getToolTipData(folder) {
    // console.log('folder for tooltip', folder)
    if (folder && folder.status) {
      let status = folder.status.isRead ? '' : 'Not Read'
      let shared = folder.status.sharedAt ? moment(folder.status.sharedAt).format('MM/DD/YYYY') : ''
      let read = folder.status.readAt && folder.status.isRead ? '\n Read On: ' + moment(folder.status.readAt).format('MM/DD/YYYY') : ''
      return status + '\n' + 'Shared On: ' + shared + read
    }
    else return null
  }
  // onHoverFolder(i) {
  //   console.log("on hover i", i)
  //   this.newFolderIndex = i
  //   let folderName
  //   if (i < this.allFolders.length) {
  //     folderName = this.allFolders[i].title
  //     this.destFolderName = folderName
  //     this.folderName.emit(folderName)
  //     // console.log('sorting event on HOVER', folderName)
  //   }
  // }
  // onFolderLeave(i) {
  //   console.log("on FOLDER leave", i)
  //   this.newFolderIndex = -1
  //   this.destFolderName = ''
  // }
}
